import {
    ROLE_PARTNER,
    ROLE_ADMIN,
    ROLE_ANALYST,
    ROLE_ANALYST_ADMIN
} from "src/components/constants";

import {
    ROUTE_PATH_ADMIN_HOME,
    ROUTE_PATH_ADMIN_USER_LIST,
    ROUTE_PATH_ADMIN_REPORT_ANONYMOUSLY,
    ROUTE_PATH_ADMIN_REPORT_CONFIDENTLY,
    ROUTE_PATH_ADMIN_SETTINGS,
    ROUTE_PATH_ADMIN_CUSTOMIZATION,
    ROUTE_PATH_ADMIN_DOCUMENTS,
    ROUTE_PATH_ADMIN_KANBAN_BOARD,
    ROUTE_PATH_ADMIN_QUESTION_GENERATOR,
    ROUTE_PATH_ADMIN_E_LEARNING,
    ROUTE_PATH_ADMIN_DASHBOARD,
    ROUTE_PATH_ADMIN_TUTORIAL,
    ROUTE_PATH_ADMIN_HISTORY_LOG,
    ROUTE_PATH_PARTNER_CLIENT_MANAGEMENT,
    ROUTE_PATH_ADMIN_RISK_MANAGMENT,
    ROUTE_PATH_ADMIN_ENTITY_MANAGMENT,
    ROUTE_PATH_ADMIN_PLATFORM_UPDATE,
    ROUTE_PATH_ADMIN_ORDERS
} from "src/common/constants";

import {
    ROUTE_PATH_EMAIL_INBOX,
} from "src/modules/mailer/constants";

const AdminMenuItems = [
    {
        titleKey    :   "Dashboard",
        path        :   ROUTE_PATH_ADMIN_DASHBOARD,
        icon        :   "ri-home-4-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Cases",
        path        :   ROUTE_PATH_ADMIN_HOME,
        // Case details live under /admin/report/*, not /admin/home
        matchPaths  :   ["/admin/report"],
        icon        :   "ri-archive-fill",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Kanban Board",
        path        :   ROUTE_PATH_ADMIN_KANBAN_BOARD,
        icon        :   "ri-bar-chart-2-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [
            'kanban-board'
        ],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Administration",
        path        :   null,
        icon        :   "ri-admin-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null,
        items: [
            {
                titleKey    :   "Settings",
                path        :   ROUTE_PATH_ADMIN_SETTINGS,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Customisation",
                path        :   ROUTE_PATH_ADMIN_CUSTOMIZATION,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Entity Management",
                path        :   ROUTE_PATH_ADMIN_ENTITY_MANAGMENT,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [
                    'entity_management'
                ],
                roles           :   [
                    ROLE_ADMIN,
                    ROLE_ANALYST_ADMIN
                ],
                customValidator :   null
            },
            {
                titleKey    :   "Subscription Management",
                path        :   ROUTE_PATH_ADMIN_ORDERS,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [
                    'subscription_report'
                ],
                roles           :   [
                    ROLE_ADMIN,
                    ROLE_ANALYST_ADMIN
                ],
                customValidator :   null
            },
            {
                titleKey    :   "History logs",
                path        :   ROUTE_PATH_ADMIN_HISTORY_LOG,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [
                    "history-logs"
                ],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Documents",
                path        :   ROUTE_PATH_ADMIN_DOCUMENTS,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [
                    'Documents'
                ],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "User Management",
                path        :   ROUTE_PATH_ADMIN_USER_LIST,
                // AD settings / add / edit live under /users/* beyond the list URL
                matchPaths  :   [
                    "/admin/administration/users/ad-settings",
                    "/admin/administration/users/add",
                    "/admin/administration/users/:id/edit",
                ],
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Questionnaire Designer",
                path        :   ROUTE_PATH_ADMIN_QUESTION_GENERATOR,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [
                    "question-generator"
                ],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Partner Client Management",
                path        :   ROUTE_PATH_PARTNER_CLIENT_MANAGEMENT,
                // Detail uses singular /client/:id
                matchPaths  :   ["/admin/administration/client"],
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   null,
                moduleFeatures  :   [],
                roles           :   [
                    ROLE_PARTNER
                ],
                customValidator :   (data) => {
                    return data?.user?.isPartner
                }
            }
        ]
    },
    {
        titleKey    :   "Add a new Case",
        path        :   null,
        icon        :   "ri-mail-send-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null,
        items: [
            {
                titleKey    :   "Report anonymously",
                path        :   ROUTE_PATH_ADMIN_REPORT_ANONYMOUSLY,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   "isAnonymously",
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            },
            {
                titleKey    :   "Report confidentially",
                path        :   ROUTE_PATH_ADMIN_REPORT_CONFIDENTLY,
                linkType    :   "react-router",
                authProtected   :   true,
                settingKey      :   "isConfidentially",
                moduleFeatures  :   [],
                roles           :   [],
                customValidator :   null
            }
        ],
    },
    {
        titleKey    :   "Mailbox",
        path        :   ROUTE_PATH_EMAIL_INBOX,
        // Folders/compose/message live under /admin/email/*, not only /inbox
        matchPaths  :   ["/admin/email"],
        icon        :   "ri-mail-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   ['mailer'],
        roles           :   [
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "Risk Management",
        path        :   ROUTE_PATH_ADMIN_RISK_MANAGMENT,
        icon        :   "ri-error-warning-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [
            'risk-assessment'
        ],
        roles           :   [
            ROLE_ADMIN,
            ROLE_ANALYST,
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "E-Learning",
        path        :   ROUTE_PATH_ADMIN_E_LEARNING,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   "isElearning",
        moduleFeatures  :   [],
        roles           :   [],
        customValidator :   null
    },
    {
        titleKey    :   "Tutorial",
        path        :   ROUTE_PATH_ADMIN_TUTORIAL,
        icon        :   "ri-video-line",
        linkType    :   "react-router",
        authProtected   :   true,
        settingKey      :   null,
        moduleFeatures  :   [],
        roles           :   [
            ROLE_ADMIN,
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    },
    {
        titleKey    :   "What’s New",
        path        :   ROUTE_PATH_ADMIN_PLATFORM_UPDATE,
        icon        :   "ri-newspaper-line",
        linkType    :   "react-router",
        moduleFeatures  :   [],
        authProtected   :   true,
        settingKey      :   null,
        roles           :   [
            ROLE_ANALYST_ADMIN
        ],
        customValidator :   null
    }
];

export default AdminMenuItems;